/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdminAddContactInfoConfirmationActionEnum {
  merge = "merge",
  steal = "steal",
}

export enum AutoMessageStatus {
  active = "active",
  draft = "draft",
  inactive = "inactive",
}

/**
 * https: // github.com/remind101/r101-api/blob/4649ee86a7132d4b21fd9236e9ff57b5906854e4/app/loaders/related_user_view.rb#L124-L138
 */
export enum ChatEligibilityState {
  eligible = "eligible",
  pending = "pending",
  unavailable = "unavailable",
  under_13 = "under_13",
  unknown = "unknown",
}

export enum ClassMembershipRole {
  owner = "owner",
  subscriber = "subscriber",
}

export enum ClassMembershipsSortDirection {
  asc = "asc",
  desc = "desc",
}

export enum ClassMembershipsSortType {
  first_name = "first_name",
  join_date = "join_date",
  joined_remind_date = "joined_remind_date",
  last_name = "last_name",
  role = "role",
}

export enum ClassSearchability {
  searchable = "searchable",
  unsearchable = "unsearchable",
}

export enum ClassType {
  available = "available",
  district = "district",
  organization = "organization",
  owned = "owned",
  pending = "pending",
  subscribed = "subscribed",
}

export enum CoachingSessionType {
  instance = "instance",
  recurringSchedule = "recurringSchedule",
}

export enum CoachingUserType {
  coach = "coach",
  participant = "participant",
}

export enum ComposerMessageType {
  announcement = "announcement",
  conversation = "conversation",
  urgent_announcement = "urgent_announcement",
}

export enum ContactabilityStatus {
  ghost = "ghost",
  poor = "poor",
  rich = "rich",
  uncontactable = "uncontactable",
}

export enum DayOfWeek {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export enum DeliverySummaryUnidentifiableReason {
  missing_parents = "missing_parents",
  missing_student = "missing_student",
}

export enum DeviceType {
  apns = "apns",
  email = "email",
  gcm = "gcm",
  landline = "landline",
  sms = "sms",
}

export enum DistanceLearningMemberSessionRole {
  host = "host",
  participant = "participant",
  unknown = "unknown",
}

export enum DistanceLearningSessionMediaType {
  screenshot = "screenshot",
  unknown = "unknown",
  video = "video",
}

export enum DistanceLearningSessionStatus {
  finished = "finished",
  pending = "pending",
  started = "started",
  unknown = "unknown",
}

export enum LanguageSetInputTargetType {
  group = "group",
  groupChat = "groupChat",
  individual = "individual",
  organization = "organization",
}

export enum LanguageSetRecipientsRole {
  admin = "admin",
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export enum LegacyMessageStatus {
  failed = "failed",
  pending = "pending",
  received = "received",
  scheduled = "scheduled",
  sent = "sent",
}

export enum LegacyUserRole {
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export enum MediumEnum {
  apns = "apns",
  email = "email",
  fake = "fake",
  gcm = "gcm",
  landline = "landline",
  sms = "sms",
}

export enum MessageRecipientsRole {
  admin = "admin",
  everyone = "everyone",
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export enum MessageTranslationIntent {
  auto = "auto",
  edited = "edited",
  off = "off",
}

export enum MessageTranslationSource {
  custom = "custom",
  detectLanguage = "detectLanguage",
  gct = "gct",
  off = "off",
  unknown = "unknown",
}

export enum NavigationListActionTarget {
  create_group = "create_group",
  join_group = "join_group",
}

export enum NavigationListEntityType {
  group = "group",
  organization = "organization",
}

export enum OrgPermission {
  can_send_auto_message = "can_send_auto_message",
}

export enum OrgRole {
  admin = "admin",
  everyone = "everyone",
  parent = "parent",
  rce = "rce",
  staff = "staff",
  student = "student",
  teacher = "teacher",
  unknown = "unknown",
}

export enum OrganizationRole {
  admin = "admin",
  parent = "parent",
  rce = "rce",
  staff = "staff",
  student = "student",
  teacher = "teacher",
}

export enum OrganizationRoleOrUnknown {
  admin = "admin",
  parent = "parent",
  rce = "rce",
  staff = "staff",
  student = "student",
  teacher = "teacher",
  unknown = "unknown",
}

/**
 * https: // github.com/remind101/r101-api/blob/8d1121436a6ae5e5f955330dd31b3209fc2f1e82/app/loaders/organization.rb#L25
 */
export enum OrganizationType {
  District = "District",
  School = "School",
}

export enum ParticipantMessagingState {
  open = "open",
  ownerOrSameRole = "ownerOrSameRole",
  ownersOnly = "ownersOnly",
}

export enum PauseReason {
  cannot_commit_to_schedule = "cannot_commit_to_schedule",
  only_school_year = "only_school_year",
  only_summer = "only_summer",
  other = "other",
  prefer_not_to_say = "prefer_not_to_say",
  vacation = "vacation",
}

export enum PurchaserRole {
  Parent = "Parent",
  Student = "Student",
}

export enum QuoteScreen {
  quote_screen_1 = "quote_screen_1",
  quote_screen_2 = "quote_screen_2",
  quote_screen_3 = "quote_screen_3",
}

/**
 * TODO: Remove. Old Reachability
 */
export enum ReachabilityMedium {
  Email = "Email",
  Landline = "Landline",
  Mobile = "Mobile",
  Text = "Text",
  Web = "Web",
}

export enum ReachabilityState {
  active = "active",
  unreachable = "unreachable",
}

export enum ReachabilityStatus {
  poor = "poor",
  rich = "rich",
  unreachable = "unreachable",
}

export enum RoleBasedMessagingAudience {
  admin = "admin",
  everyone = "everyone",
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export enum SelfServeHelpScreen {
  help_request_screen_1 = "help_request_screen_1",
  help_request_screen_2 = "help_request_screen_2",
  help_request_screen_3 = "help_request_screen_3",
}

export enum SelfServeHelpScreenSource {
  admin_contact = "admin_contact",
  admin_onboarding = "admin_onboarding",
  marketing_page = "marketing_page",
  self_serve = "self_serve",
  self_serve_v2 = "self_serve_v2",
}

export enum SetLanguageForUserInputTargetType {
  group = "group",
  organization = "organization",
}

export enum SftpFeature {
  AutoMessaging = "AutoMessaging",
}

export enum SisSyncIssueSeverity {
  alert = "alert",
  error = "error",
}

/**
 * Can be any of the types returned by /v2/devices.
 */
export enum SubscriptionMedium {
  apns = "apns",
  email = "email",
  gcm = "gcm",
  landline = "landline",
  sms = "sms",
  web = "web",
}

export enum SyncType {
  aeries = "aeries",
  classlink = "classlink",
  clever = "clever",
  none = "none",
  oneRosterSpreadsheet = "oneRosterSpreadsheet",
  remindSpreadsheet = "remindSpreadsheet",
  remindSpreadsheetV2 = "remindSpreadsheetV2",
}

export enum TimeslotFrequencyInput {
  everyOtherWeek = "everyOtherWeek",
  once = "once",
  weekly = "weekly",
}

export enum UnfulfilledReason {
  coach_paused = "coach_paused",
  newly_materialized_conflict = "newly_materialized_conflict",
  override = "override",
  schedule_changed = "schedule_changed",
  unknown = "unknown",
}

export enum UserDefinedOrganizationType {
  District = "District",
  HigherEducation = "HigherEducation",
  Other = "Other",
  School = "School",
}

export enum UserSelectedRole {
  admin = "admin",
  parent = "parent",
  student = "student",
  teacher = "teacher",
}

export interface AddRemoveAdminInput {
  organizationId: number;
  userUuid: string;
}

export interface AddUsersToGroupInput {
  groupUuid: string;
  uuids: string[];
}

/**
 * Autogenerated input type of AdminAddContactInfoToUser
 */
export interface AdminAddContactInfoToUserInput {
  deviceUid: string;
  targetUserUuid: string;
  organizationUuid: string;
  confirmAction?: AdminAddContactInfoConfirmationActionEnum | null;
  deviceUidToRemove?: string | null;
  clientMutationId?: string | null;
}

/**
 * Autogenerated input type of AdminRemoveContactInfoFromUser
 */
export interface AdminRemoveContactInfoFromUserInput {
  userUuid: string;
  deviceUuid: string;
  organizationUuid: string;
  clientMutationId?: string | null;
}

export interface ApproveGroupMembershipRequestsInput {
  groupUuid: string;
  requestUuids: string[];
}

export interface ApproveRoleRequestsInput {
  organizationUuid: string;
  uuids: string[];
}

export interface AutoMessageContentInput {
  body: string;
  fileAttachmentUuids?: (string | null)[] | null;
}

export interface AutoMessageSenderInput {
  uuid: string;
  type: string;
}

export interface AvailabilityRuleInput {
  uuid: string;
  startTime: any;
  endTime: any;
  dayOfWeek: DayOfWeek;
}

export interface AvailabilityScheduleInput {
  uuid: string;
  label: string;
  startDate: any;
  availabilityRules: AvailabilityRuleInput[];
  maxDailySessions: MaxDailySessionsInput[];
}

export interface CancelGroupMembershipRequestInput {
  groupUuid: string;
}

export interface ClaimAccountScreenInput {
  claimToken: string;
}

export interface ClaimDeviceInput {
  claimToken: string;
  mergeAccounts: boolean;
}

export interface CoachingEventDefinitionInput {
  startDateTime: string;
  endDateTime: string;
  recurrence?: string[] | null;
  timezone: string;
}

export interface CoachingParticipantInput {
  purchaserUuid: string;
  studentUuid: string;
  studentName: string;
  timezone: string;
  whiteboardUrl: string;
  distanceLearningPermalink: string;
  subjects: string[];
}

export interface CoachingSessionInput {
  participantUuid: string;
  coachUuid: string;
  eventDefinition: CoachingEventDefinitionInput;
  subjectUuid?: string | null;
}

export interface CreateAndChargeNewOrgCardInput {
  orgUuid: string;
  orgId: number;
  stripeSourceId: string;
  amount: number;
  quoteUuid: string;
}

export interface CreateOrganizationUnauthedInput {
  name: string;
  city: string;
  state: string;
  country?: string | null;
  type: OrganizationType;
  clientUuid: string;
}

export interface CreateRosteringJobInput {
  sourceDistrictId: string;
  remindDistrictUuid: string;
  schools: SourceSchool[];
  configKey?: string | null;
}

export interface DeleteAutoMessageInput {
  uuid: string;
}

export interface DeliveryReportInput {
  streamUuid: string;
  messageUuid: string;
}

export interface DenyGroupMembershipRequestsInput {
  groupUuid: string;
  requestUuids: string[];
}

export interface DenyRoleRequestsInput {
  organizationUuid: string;
  denials: RoleRequestDenial[];
}

export interface DetectLanguageInput {
  text: string;
}

export interface DirectAddAdminInput {
  organizationId: number;
  name: string;
  email: string;
}

export interface EditFeatureSftpCredentialsInput {
  orgUuid: string;
  username: string;
  displayName: string;
  featureName: SftpFeature;
}

export interface GenerateFeatureSftpCredentialsInput {
  orgUuid: string;
  displayName: string;
  featureName: SftpFeature;
}

export interface JoinGroupByCodeInput {
  groupCode: string;
  message?: string | null;
}

export interface LanguageSetFiltersInput {
  roles?: LanguageSetRecipientsRole[] | null;
}

export interface LanguageSetInput {
  targetType: LanguageSetInputTargetType;
  targetUuid: string;
  filters?: LanguageSetFiltersInput | null;
}

export interface LeadInput {
  requesterFirstName: string;
  requesterLastName: string;
  requesterEmail: string;
  requesterPhoneNumber?: string | null;
  orgType: UserDefinedOrganizationType;
  orgName: string;
  orgPostalCode: string;
  orgCountry: string;
  studentsCount: number;
  clientUuid: string;
  source?: string | null;
}

export interface LinkPreviewInput {
  url: string;
  title: string;
  description?: string | null;
  image?: string | null;
  image_width?: string | null;
  image_height?: string | null;
  rich_content_type?: string | null;
  rich_content_url?: string | null;
}

export interface MaxDailySessionsInput {
  maxSessions: number;
  dayOfWeek: DayOfWeek;
}

export interface MessageInput {
  body?: string | null;
  fileUuids?: string[] | null;
  linkPreviews?: LinkPreviewInput[] | null;
  urgent?: boolean | null;
  translations?: MessageTranslationsInput | null;
  personalizedVoiceMessage?: boolean | null;
}

export interface MessageTargetFilterInput {
  roles?: MessageRecipientsRole[] | null;
}

export interface MessageTranslationsInput {
  autoTranslateAll?: boolean | null;
  translated?: boolean | null;
  originalLanguageCode?: string | null;
  targetLanguageCodes?: string[] | null;
  predefinedTranslations?: PredefinedMessageTranslationsInput[] | null;
}

export interface NewUserAccountInput {
  purchaserName: string;
  email: string;
  purchaserRole: PurchaserRole;
}

export interface OrganizationAddressInput {
  latitude?: number | null;
  longitude?: number | null;
  streetAddress: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface PredefinedMessageTranslationsInput {
  languageCode: string;
  translatedText: string;
  translationSource: MessageTranslationSource;
  translationIntent?: MessageTranslationIntent | null;
}

export interface PutMessageInput {
  uuid?: string | null;
  recipients: RecipientInput[];
  message: MessageInput;
  sender?: SenderInput | null;
}

export interface PutStudentIdListInput {
  uuid: string;
  fileUuid: string;
  organizationUuid: string;
  includeParents?: boolean | null;
  includeStudents?: boolean | null;
}

export interface QueryOrganizationsByNameInput {
  name: string;
}

export interface QuoteInput {
  organizationUuid: string;
  studentsCount: number;
  teachersCount: number;
  startDate: string;
  organizationAddress: OrganizationAddressInput;
  requesterFirstName?: string | null;
  requesterLastName?: string | null;
  requesterEmail?: string | null;
  requesterPhoneNumber: string;
  requesterRole?: string | null;
  billingFirstName?: string | null;
  billingLastName?: string | null;
  billingEmail?: string | null;
  billingPhoneNumber?: string | null;
  taxExempt?: boolean | null;
  purchaseOrderNumber?: string | null;
  lastScreenName?: string | null;
  screen?: QuoteScreen | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmContent?: string | null;
  utmCampaign?: string | null;
  experiment?: string | null;
  experimentVariant?: string | null;
}

export interface RecipientInput {
  type: string;
  uuid: string;
  role?: MessageRecipientsRole | null;
  filters?: MessageTargetFilterInput[] | null;
}

export interface RemoveGroupFromOrgInput {
  groupUuid: string;
  organizationUuid: string;
  reason?: string | null;
}

export interface RemoveUsersFromGroupInput {
  groupUuid: string;
  ids: number[];
}

export interface ReportUserInput {
  userUuid: string;
  reason: string;
  key?: string | null;
}

export interface RequestAccessForPaidUpsellInput {
  organizationUuid: string;
  context: string;
  adminReferrals?: string[] | null;
  permissionToUseName: boolean;
}

export interface ResendUnclaimedNotificationInput {
  orgUuid: string;
}

export interface ResumeRosteringInput {
  orgUuid: string;
  holdKey: string;
  skipPermanently: boolean;
  skipUntilSuccessful: boolean;
}

export interface RevokeFeatureSftpCredentialsInput {
  orgUuid: string;
  featureName: SftpFeature;
  username: string;
}

export interface RoleRequestDenial {
  uuid: string;
  message?: string | null;
}

export interface SaveAutoMessageInput {
  uuid?: string | null;
  messageName?: string | null;
  csvName?: string | null;
  orgUuid?: string | null;
  creatorOrgUuid?: string | null;
  includeParents?: boolean | null;
  includeStudents?: boolean | null;
  sender?: AutoMessageSenderInput | null;
  messageContent?: AutoMessageContentInput | null;
  sftpCredentialsUsername?: string | null;
  customMessageFields?: string[] | null;
  isUrgent?: boolean | null;
}

export interface SaveCoachPauseInput {
  coachUuid?: string | null;
  uuid: string;
  effectiveDate: any;
  reason: PauseReason;
  returnDate?: any | null;
  details?: string | null;
}

export interface ScheduleMessageInput {
  messageInput: PutMessageInput;
  sendAt?: string | null;
}

export interface SchoolMappingInput {
  schoolId: string;
  remindSchoolUuid: string;
}

export interface SelfServeHelpInput {
  organizationUuid: string;
  requesterFirstName?: string | null;
  requesterLastName?: string | null;
  requesterEmail?: string | null;
  requesterPhoneNumber: string;
  requesterRole?: string | null;
  quoteUuid?: string | null;
  studentsCount: number;
  teachersCount: number;
  screen?: SelfServeHelpScreen | null;
  source?: SelfServeHelpScreenSource | null;
  comment?: string | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmContent?: string | null;
  utmCampaign?: string | null;
  experiment?: string | null;
  experimentVariant?: string | null;
}

export interface SendActivationNotificationsInput {
  orgUuid: string;
  roles: string[];
}

export interface SenderInput {
  type: string;
  uuid: string;
}

export interface SetAutoMessageStatusInput {
  uuid: string;
  status: AutoMessageStatus;
}

export interface SetDistrictSettingsInput {
  orgId: number;
  schoolAdminsCanSendUrgentMessage: boolean;
}

export interface SetLanguageForUserInput {
  userUuid: string;
  targetUuid: string;
  targetType: SetLanguageForUserInputTargetType;
  preferredLanguageCode: string;
}

export interface SetOrgApprovalSettingsInput {
  orgUuid: string;
  gateTeacherRole: boolean;
  gateClasses: boolean;
}

export interface SetOrgSettingsInput {
  orgUuid: string;
  orgRequestToJoinEnabledDefault: boolean;
  orgSearchabilityDefault: ClassSearchability;
  orgParticipantMessagingDefault: ParticipantMessagingState;
  backfillExistingClasses: boolean;
}

export interface SetRequestToJoinInput {
  groupUuid: string;
  enabled: boolean;
}

export interface SetRosteringEnforcementInput {
  orgUuid: string;
  allowedToLeave: boolean;
}

export interface SingleDayAvailabilityOverrideInput {
  uuid: string;
  date: any;
  availabilityRules: AvailabilityRuleInput[];
}

export interface SourceSchool {
  source_id: string;
  source_name: string;
  remind_org_uuid: string;
}

export interface TranslatedMessageInput {
  languageCode: string;
  text: string;
  targetLanguageCode: string;
}

export interface UpdateClassSettingsScreenInput {
  organizationUuid?: string | null;
  className?: string | null;
  classCode?: string | null;
  willOnlyMessage13AndOlder?: boolean | null;
  requestToJoinEnabled?: boolean | null;
  searchability?: ClassSearchability | null;
  participantMessagingState?: ParticipantMessagingState | null;
  isSearchable?: boolean | null;
}

export interface UpdateContentSourceProviderInput {
  title: string;
  providerIconUrl?: string | null;
  providerIconFileUUID?: string | null;
  organizationUUID: string;
  contentWebhookUrl: string;
  enabledByProvider: boolean;
  bigPreviewWebhookUrl: string;
  productLongDescription: string;
  productShortDescription: string;
}

export interface UpdateLinkedAccountProviderOauthConfigInput {
  authUrl: string;
  clientId: string;
  tokenUrl: string;
  scopes: string[];
  providerKey: string;
  clientSecret: string;
  organizationUUID: string;
}

export interface UpdateSchoolMappingsInput {
  districtUuid: string;
  schools: SchoolMappingInput[];
}

export interface UpdateUserByIDInput {
  id?: number | null;
  uuid?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  organization_uuid?: string | null;
  group_uuid?: string | null;
}

export interface UpdateUserNoteInput {
  userId: number;
  note: string;
}

/**
 * Some ACI setup do not require configs, for example Schoology.
 */
export interface UpsertAdminControlledIntegrationInput {
  config?: UpsertAdminControlledIntegrationInputConfig | null;
  initialIntegrationKey?: string | null;
  enabledByOrg?: boolean | null;
}

export interface UpsertAdminControlledIntegrationInputConfig {
  clientID: string;
  clientSecret: string;
  installationURLDomain: string;
}

export interface UpsertAdminToggledPartnerIntegrationInput {
  orgUuid: string;
  providerKey: string;
  isEnabled: boolean;
}

export interface UserNameChangeBanInput {
  user_identifier: string;
}

export interface UserProfileScreenInput {
  relatedUserUuid: string;
  groupUuid?: string | null;
  organizationUuid?: string | null;
}

export interface VerifyDeviceForAccountMergeInput {
  code: string;
  address: string;
}

export interface addDeviceToUserInput {
  userId: string;
  address: string;
}

export interface deleteLTIInput {
  organizationUUID: string;
  serviceKey: string;
}

export interface rotateLTICredentialsInput {
  organizationUUID: string;
  serviceKey: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
